import { render } from "./all-evaluasi.vue?vue&type=template&id=7cb4fc22"
import script from "./all-evaluasi.vue?vue&type=script&lang=js"
export * from "./all-evaluasi.vue?vue&type=script&lang=js"

import "./all-evaluasi.vue?vue&type=style&index=0&id=7cb4fc22&lang=css"

import exportComponent from "/home/alfahuma/manual_build/digita-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__